<p class="text-left no-margin">
  <b>Safra:</b> {{schedule.safra.descricao}} <br>
  <b>Atividade:</b> {{schedule.atividade.descricao}} <br>
  <span ng-if="schedule.cultivar">
    <b>Cultivar:</b> {{schedule.cultivar.descricao}} <br>
  </span>
  <b>Plantio:</b> {{schedule.data_plantio | date: 'dd/MM/yy'}} <br>
  <b>Data estimada de colheita:</b> {{schedule.data_estimada_colheita | date: 'dd/MM/yy'}} <br>
  <b>Emergência:</b> {{schedule.data_emergencia | date: 'dd/MM/yy'}} <br>
  <b>Ciclo:</b> {{schedule.ciclo_dias}} dias <br>
  <b>Dias do ciclo até hoje:</b> {{schedule.dias_do_ciclo_ate_hoje}}
</p>
